import { render, staticRenderFns } from "./presupuesto.vue?vue&type=template&id=cdba853c&"
import script from "./presupuesto.vue?vue&type=script&lang=js&"
export * from "./presupuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports